<template>
    <b-container fluid class="mt--7">
        <b-row>
            <b-col>
                <b-card>
                    <b-card-header
                        class="card-header border-0"
                        :class="type === 'dark' ? 'bg-transparent' : ''"
                    >
                        <b-row>
                            <b-col cols="10">
                                <b-input
                                    placeholder="Filter..."
                                    v-model="query"
                                ></b-input>
                            </b-col>
                            <b-col class="text-right">
                                <slot></slot>
                            </b-col>
                        </b-row>
                    </b-card-header>

                    <b-card-body>
                        <b-table
                            :items="users"
                            :fields="fields"
                            striped
                            hover
                            responsive
                        >
                            <template #cell(id)="row">
                                <b-button
                                    size="sm"
                                    @click="viewUser(row.value)"
                                    class="mr-2"
                                    variant="primary"
                                >
                                    View
                                </b-button>
                            </template>

                            <template #cell(name)="row">
                                <span class="name mb-0 text-sm"
                                    >{{ row.item.firstName }}
                                    {{ row.item.lastName }}</span
                                >
                            </template>

                            <template #cell(roles)="row">
                                <b-badge
                                    variant="success"
                                    v-for="(role, index) in row.item.roles"
                                    :key="index"
                                >
                                    {{ role.role.name }} </b-badge
                                ><br />
                            </template>
                        </b-table>

                        <b-row>
                            <b-col>
                                <b-pagination
                                    class="float-right"
                                    v-model="pagination.page"
                                    :total-rows="pagination.total"
                                    :per-page="pagination.pageSize"
                                    aria-controls="customerTable"
                                    pills
                                    align="right"
                                ></b-pagination>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import _ from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'users-table',
    mixins: [popupMixins, permissionsMixins],
    props: {
        type: {
            type: String,
        },
        title: String,
    },
    data() {
        return {
            query: '',
            fields: [{ key: 'id', label: 'Actions' }, 'name', 'roles', 'email'],
        }
    },
    watch: {
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
    },

    mounted() {
        this.$store.dispatch('roles/fetch', {
            query: '',
            page: 1,
        })
        this.$store.dispatch('permissions/all')

        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },

    methods: {
        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        doSearch() {
            const {
                query,
                pagination: { page },
            } = this
            this.$store.dispatch('users/fetchUsers', {
                query,
                page,
            })
        },
        viewUser(index) {
            const path = `${this.$route.path}/${index}`
            this.$router.push({ path })
        },
    },

    computed: {
        users() {
            return this.$store.state.users.users
        },
        user() {
            return this.$store.state.user
        },

        pagination() {
            return this.$store.state.users.pagination || {}
        },
    },
}
</script>
<style></style>
